import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlay, faCirclePause } from "@fortawesome/free-solid-svg-icons";
import { createGIF } from "gifshot-plus";
import { createClient } from "@supabase/supabase-js";
import logo from "../assets/logo.png"

const projectURL = "https://bzadugmbzathrddoggvu.supabase.co";
const anonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJ6YWR1Z21iemF0aHJkZG9nZ3Z1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDAzMjQzNDQsImV4cCI6MjAxNTkwMDM0NH0.wrEDO90ljV4DQQioqrf9fffTv2nY82iXb537L82e-Zk";
const supabase = createClient(projectURL, anonKey);

var sketches = [];

const getAllSketches = async () => {
    if (sketches.length == 0) {
        const { data, error } = await supabase
        .storage
        .from('sketches')
        .list("", {
            sortBy: { column: 'created_at', order: 'asc' }
        });
        if (error) {
            throw error
        }
        for (let index = 0; index < data.length; index++) {
            const fileName = data[index].name;
            var publicURL = "https://bzadugmbzathrddoggvu.supabase.co/storage/v1/object/public/sketches/" + fileName;
            sketches.push(publicURL);
        }
    }

    return sketches;
  }


function Post() {
    const [isPlaying, setIsPlaying] = useState(false);

    const button = isPlaying ? <FontAwesomeIcon icon={faCirclePause} /> : <FontAwesomeIcon icon={faCirclePlay} />;

    const handleClick = async () => {

        setIsPlaying(!isPlaying);

        var animatedImage = document.getElementById("gif-final-image");

        if (!isPlaying) {
            var allSketches = await getAllSketches();
            createGIF({
                'images': allSketches,
                gifWidth: 1280,
                gifHeight: 720,
                frameDuration: 2,
                saveRenderingContexts: true
                }, function(obj) {
                if (!obj.error) {
                    var image = obj.image;
                    animatedImage.src = image;
                }
            })
        }
        else {
            animatedImage.src = "https://bzadugmbzathrddoggvu.supabase.co/storage/v1/object/public/sketches/sketch_1.png";
        }
    }

    return (
        <div id="post">
            <a href="/"><img src={logo} alt="Cadavre Exquis" className="logo index"></img></a>
            <p>Thank you for your contribution. Here is the full animation:</p>
            <div onClick={handleClick} id="gif-final">
                <img id="gif-final-image" className={isPlaying ? "playing" : "paused"} src={"https://bzadugmbzathrddoggvu.supabase.co/storage/v1/object/public/sketches/sketch_1.png"} width={1280} height={720} />
                <div id="play-button" className={isPlaying ? "playing" : "paused"}>{button}</div>
            </div>
        </div>
    )
}

export default Post